exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".project-category-items .el-form-item{margin-bottom:22px}.project-category-items .array-item{-webkit-transform:scale(.9);transform:scale(.9)}.project-category-items .array-item .el-form-item__label{cursor:move}", "", {"version":3,"sources":["/workspace/src/views/occupation-questionnaire/components/SjFormSubsets.vue"],"names":[],"mappings":"AACA,sCAAsC,kBAAkB,CACvD,AACD,oCAAoC,4BAA6B,mBAAoB,CACpF,AACD,yDAAyD,WAAW,CACnE","file":"SjFormSubsets.vue","sourcesContent":["\n.project-category-items .el-form-item{margin-bottom:22px\n}\n.project-category-items .array-item{-webkit-transform:scale(0.9);transform:scale(0.9)\n}\n.project-category-items .array-item .el-form-item__label{cursor:move\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38c501b6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/occupation-questionnaire/components/SjFormSubsets.vue
// module id = 4574
// module chunks = 60